<mat-tab-group class="w-full">
  <mat-tab label="Questions">
    <ng-template mat-tab-label>
      Questions
    </ng-template>
    <ng-template matTabContent>
      <app-test-survey-questions></app-test-survey-questions>
    </ng-template>
  </mat-tab>
  <mat-tab label="Ext">
    <ng-template mat-tab-label>
      Ext
    </ng-template>
    <ng-template matTabContent>
      <app-test-survey-ext></app-test-survey-ext>
    </ng-template>
  </mat-tab>
<!--  <mat-tab label="Manager">-->
<!--    <ng-template mat-tab-label>-->
<!--      Manager-->
<!--    </ng-template>-->
<!--    <ng-template matTabContent>-->
<!--      <app-test-survey-manager></app-test-survey-manager>-->
<!--    </ng-template>-->
<!--  </mat-tab>-->
</mat-tab-group>
